import { render, staticRenderFns } from "./Pillgroup.vue?vue&type=template&id=7531fad0&scoped=true&"
import script from "./Pillgroup.vue?vue&type=script&lang=js&"
export * from "./Pillgroup.vue?vue&type=script&lang=js&"
import style0 from "./Pillgroup.vue?vue&type=style&index=0&id=7531fad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531fad0",
  null
  
)

export default component.exports